/**
 * 工作流边组件导出
 *
 * 统一导出所有边组件和 edgeTypes 映射
 */

import type { EdgeTypes } from '@xyflow/react';

// 导出边组件
export { ButtonEdge, getEdgeExecutionStatus } from './ButtonEdge';
export type { ButtonEdgeData, ButtonEdgeType, ButtonEdgeProps } from './ButtonEdge';

// 导入边组件用于 edgeTypes 映射
import { ButtonEdge } from './ButtonEdge';

/**
 * 边类型映射
 *
 * 用于 ReactFlow 的 edgeTypes 属性
 * key 对应边 type，value 对应组件
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const edgeTypes: EdgeTypes = {
  default: ButtonEdge as any,
  button: ButtonEdge as any,
};

/**
 * 默认边选项
 *
 * 用于 ReactFlow 的 defaultEdgeOptions 属性
 */
export const defaultEdgeOptions = {
  type: 'default',
  animated: false,
  style: {
    strokeWidth: 2,
    stroke: '#9ca3af', // gray-400
  },
  markerEnd: {
    type: 'arrowclosed' as const,
    color: '#9ca3af',
    width: 15,
    height: 15,
  },
};

/**
 * 边样式配置
 */
export const edgeStyles = {
  // 默认边样式
  default: {
    stroke: '#9ca3af', // gray-400
    strokeWidth: 2,
  },
  // 执行中边样式
  running: {
    stroke: '#6366f1', // agent-500
    strokeWidth: 2,
  },
  // 已完成边样式
  completed: {
    stroke: '#10b981', // success-500
    strokeWidth: 2,
  },
  // 失败边样式
  failed: {
    stroke: '#ef4444', // error-500
    strokeWidth: 2,
  },
  // 选中边样式
  selected: {
    stroke: '#6366f1', // agent-500
    strokeWidth: 3,
  },
};

/**
 * 获取边样式
 *
 * @param status 边执行状态
 * @param selected 是否选中
 */
export function getEdgeStyle(status?: string, selected?: boolean) {
  if (selected) {
    return edgeStyles.selected;
  }

  switch (status) {
    case 'running':
      return edgeStyles.running;
    case 'completed':
      return edgeStyles.completed;
    case 'failed':
      return edgeStyles.failed;
    default:
      return edgeStyles.default;
  }
}

/**
 * 获取边颜色
 *
 * @param status 边执行状态
 * @param selected 是否选中
 */
export function getEdgeColor(status?: string, selected?: boolean): string {
  return getEdgeStyle(status, selected).stroke as string;
}

export default edgeTypes;
